import type { FilterValue } from '../../components/ui/multipleFilters/types';
import { FilterKind } from '../../components/ui/multipleFilters/types';

import type { BackendQueryParamName, FlagFilterInterface, QueryParamName } from './flagFilterInterface';
import { FilterOperator, FlagListBackendQueryParam, FlagListQueryParam } from './types';

export class SegmentTargetedFilter implements FlagFilterInterface<string> {
  name: string;
  value: string;
  kind: FilterKind;
  queryParamName: QueryParamName;
  backendQueryParamName: BackendQueryParamName;
  operators: string[];
  defaultValue: string;

  constructor(value?: string) {
    this.name = 'Segment targeted';
    this.value = value || '';
    this.kind = FilterKind.SEGMENT_TARGETED;
    this.queryParamName = FlagListQueryParam.SEGMENT_TARGETED;
    this.backendQueryParamName = FlagListBackendQueryParam.SEGMENT_TARGETED;
    this.operators = [FilterOperator.IS];
    this.defaultValue = '';
  }

  getFilterValueDisplayName(value?: FilterValue) {
    if (typeof value === 'string') {
      return value;
    }

    return '';
  }

  getDisplayName = () => this.name;

  getOptions() {
    // Tags has it's own container to fetch value
    return [];
  }

  isEnabled = () => true;

  isEmpty = () => this.value === '';

  toQuery = () => this.value;

  isInvalidFilter = () => !this.isEmpty();

  clearFilter = () => (this.value = '');

  toBackendQuery() {
    if (this.isEmpty()) {
      return '';
    }

    return `segmentTargeted:${this.value}`;
  }

  parseFilterParam(queryParts: string[]) {
    const [, value] = queryParts;
    return value;
  }

  getFilterData() {
    // Tags has it's own container to fetch option values
    return {
      operators: this.operators,
      options: [],
      defaultValue: this.defaultValue,
    };
  }
}
